import type { SwipeDirection } from '../types';


/**
 * Returns displacement along the swipe axis relative to the drag start position.
 *
 * @param event - The pointer event.
 * @param startX - The X coordinate where the drag started.
 * @param startY - The Y coordinate where the drag started.
 * @param direction - The swipe direction.
 * @returns Signed pixel delta along the axis.
 */
export const getAxisDelta = (
    event: PointerEvent,
    startX: number,
    startY: number,
    direction: SwipeDirection,
): number => {
    if (direction === 'left' || direction === 'right') {
        return event.clientX - startX;
    }

    return event.clientY - startY;
}
